export const ENVIRONMENTS = Object.freeze({
    LIVE: 'LIVE',
    REVIEW_WEBAPP: 'REVIEW_WEBAPP',
    REVIEW: 'REVIEW',
    STAGING: 'STAGING',
    DEV: 'DEV',
    DEV_OLD: 'DEV_OLD'
});

export const getReviewEnvIdFromHost = () => parseReviewEnvironmentHost()?.reviewId || null;

export const parseReviewEnvironmentHost = () => {
    const reviewMatch = document.location.host.match(
        // eslint-disable-next-line max-len
        /^(insights-webapp|surveys-webapp|insights|surveys)-(.*?)((?:\.[^.]+)?(?:\.hotjarians\.net)|(?:\.[^.]+)?(?:\.eks\.hotjar\.com))$/
    );

    return (
        reviewMatch && {
            component: reviewMatch[1],
            reviewId: reviewMatch[2],
            domain: reviewMatch[3],
            reviewUrlSuffix: reviewMatch[2] + reviewMatch[3]
        }
    );
};

const reviewEnvUrlSuffix = parseReviewEnvironmentHost()?.reviewUrlSuffix;

export const HOSTS_PER_ENV = Object.freeze({
    [ENVIRONMENTS.LIVE]: {
        INSIGHTS: 'insights.hotjar.com',
        SURVEYS: 'surveys.hotjar.com'
    },
    [ENVIRONMENTS.REVIEW]: {
        INSIGHTS: `insights-${reviewEnvUrlSuffix}`,
        SURVEYS: `surveys-${reviewEnvUrlSuffix}`
    },
    [ENVIRONMENTS.REVIEW_WEBAPP]: {
        INSIGHTS: `insights-webapp-${reviewEnvUrlSuffix}`,
        SURVEYS: `surveys-webapp-${reviewEnvUrlSuffix}`
    },
    [ENVIRONMENTS.STAGING]: {
        INSIGHTS: 'insights-staging.hotjar.com',
        SURVEYS: 'surveys-staging.hotjar.com'
    },
    [ENVIRONMENTS.DEV]: {
        INSIGHTS: 'local.hotjar.com:8443',
        SURVEYS: 'surveys.local.hotjar.com:8443'
    },
    [ENVIRONMENTS.DEV_OLD]: {
        INSIGHTS: 'local.hotjar.com',
        SURVEYS: 'surveys.local.hotjar.com'
    }
});

const isEnvironment = (environment) => (host, hostType) => host === HOSTS_PER_ENV[environment][hostType];

const isDev = isEnvironment(ENVIRONMENTS.DEV);
const isDevOld = isEnvironment(ENVIRONMENTS.DEV_OLD);
const isLive = isEnvironment(ENVIRONMENTS.LIVE);
const isReviewWebapp = isEnvironment(ENVIRONMENTS.REVIEW_WEBAPP);
const isReview = isEnvironment(ENVIRONMENTS.REVIEW);
const isStaging = isEnvironment(ENVIRONMENTS.STAGING);

export const getEnvironment = (hostType = 'INSIGHTS', host = document.location.host) => {
    if (isLive(host, hostType)) {
        return ENVIRONMENTS.LIVE;
    }

    if (isDev(host, hostType)) {
        return ENVIRONMENTS.DEV;
    }

    if (isDevOld(host, hostType)) {
        return ENVIRONMENTS.DEV_OLD;
    }

    if (isReviewWebapp(host, hostType)) {
        return ENVIRONMENTS.REVIEW_WEBAPP;
    }

    if (isReview(host, hostType)) {
        return ENVIRONMENTS.REVIEW;
    }

    if (isStaging(host, hostType)) {
        return ENVIRONMENTS.STAGING;
    }

    return ENVIRONMENTS.LIVE;
};
